/* CUSTOM_TWOTONE_BY_CLAUDE (Ryan 2026-10-21) — the two-tone paint charge follows the colour circles.

   Eleven Legend cages and racks charge more when the uprights and the crossmembers are painted
   different colours (Legend's "2-Tone" line). When their colours became line-item-property circles
   (Legend variant collapse, batch 3) the charge stayed a REAL variant: a "Paint" option with
   "One Color" and "Two-Tone (+$89.00)". This script picks it from the circles so the customer never
   has to, and the price updates as they choose.

   The rule: every "Frame Color ..." circle group on the form agrees -> One Color; any two differ ->
   the Two-Tone value. Inert on any product without a variant value beginning "Two-Tone".

   ⚠️ THE VARIANT IS SET THREE TIMES, ON PURPOSE. The theme's variant picker moves the cart's
   `input[name="id"]` only after a server round-trip, so checking the Paint radio alone leaves a
   window in which a fast "Add to cart" posts the old variant — a two-tone cage at the one-colour
   price. So the id is written synchronously at the swatch change, and again in a CAPTURE-phase
   submit / dynamic-checkout click listener, which runs before product-form.js reads the form.

   The Paint buttons are not clickable (the circles decide), with a one-line note saying so. */
(function () {
  'use strict';
  if (window.__bsfsTwoToneBound) return;
  window.__bsfsTwoToneBound = true;

  var TWO_TONE = /^two-tone/i;
  var FRAME_PROP = /^properties\[frame color/i;

  function paintRadios(form) {
    var section = form.closest('.shopify-section') || document;
    var radios = Array.prototype.slice.call(section.querySelectorAll('variant-picker .option-selector input[type="radio"]'));
    var two = radios.filter(function (r) { return TWO_TONE.test(r.value); })[0];
    if (!two) return null;
    var group = radios.filter(function (r) { return r.name === two.name; });
    var one = group.filter(function (r) { return r !== two; })[0];
    return one ? { one: one, two: two } : null;
  }

  function wantTwoTone(form) {
    var seen = {};
    var values = [];
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.type === 'radio' && el.checked && FRAME_PROP.test(el.name) && !seen[el.name]) {
        seen[el.name] = true;
        values.push(el.value);
      }
    });
    return values.length > 1 && values.some(function (v) { return v !== values[0]; });
  }

  function sync(form) {
    if (!form) return;
    var paint = paintRadios(form);
    if (!paint) return;
    markAuto(paint.two);
    var target = wantTwoTone(form) ? paint.two : paint.one;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && target.dataset.variantId) idInput.value = target.dataset.variantId;
    if (!target.checked) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function markAuto(radio) {
    var fieldset = radio.closest('.option-selector');
    if (!fieldset || fieldset.classList.contains('bsfs-two-tone-auto')) return;
    fieldset.classList.add('bsfs-two-tone-auto');
    var note = document.createElement('p');
    note.className = 'bsfs-two-tone-note';
    note.textContent = 'Set automatically: matching colours are one color, different colours are two-tone.';
    fieldset.appendChild(note);
  }

  var style = document.createElement('style');
  style.textContent = '.bsfs-two-tone-auto .opt-label{pointer-events:none}' +
    '.bsfs-two-tone-note{margin:.6em 0 0;font-size:.9em;opacity:.7}';
  document.head.appendChild(style);

  function formsOnPage() {
    var forms = [];
    document.querySelectorAll('form').forEach(function (f) {
      if (Array.prototype.some.call(f.elements, function (el) { return FRAME_PROP.test(el.name || ''); })) forms.push(f);
    });
    return forms;
  }

  document.addEventListener('change', function (evt) {
    var el = evt.target;
    if (el && el.type === 'radio' && FRAME_PROP.test(el.name || '')) sync(el.form);
  });

  document.addEventListener('submit', function (evt) { sync(evt.target); }, true);
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('.shopify-payment-button, [name="add"]');
    if (!btn) return;
    var form = btn.form || (btn.closest('form')) || null;
    if (form) sync(form); else formsOnPage().forEach(sync);
  }, true);

  // The picker swaps in a fresh column after every variant change (on:variant:change fires BEFORE
  // the swap, so it is too early); re-mark the new Paint fieldset when it lands.
  new MutationObserver(function (records) {
    var hit = records.some(function (rec) {
      return Array.prototype.some.call(rec.addedNodes, function (n) {
        return n.nodeType === 1 && (n.matches('variant-picker, .product-options') || (n.querySelector && n.querySelector('variant-picker')));
      });
    });
    if (hit) formsOnPage().forEach(sync);
  }).observe(document.documentElement, { childList: true, subtree: true });
  function init() { formsOnPage().forEach(sync); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
/* END CUSTOM_TWOTONE_BY_CLAUDE */
